import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { 
  ICampoCustomizableCatalogo,
  ICampoCustomizableCatalogoRequest, 
  ICampoCustomizableCatalogoResponse,
  ICampoCustomizableCatalogoDeleteRequest,
  ICampoCustomizableCatalogoDeleteResponse,
  ICampoCustomizableCatalogoSaveRequest,
  ICampoCustomizableCatalogoSaveResponse,
  ITipoRequest,
  ITipoResponse,
  ITablaRequest,
  ITablaResponse
} from '../interfaces/campo-customizable-catalogo.interface';

@Injectable({
  providedIn: 'root'
})
export class CamposCustomizablesCatalogosService {

  private apiUrl = environment.apiNewBackBaseUrl;

  constructor(private http: HttpClient) { }

  getCamposCustomizablesCatalogos(request: ICampoCustomizableCatalogoRequest): Observable<ICampoCustomizableCatalogoResponse> {
    return this.http.post<ICampoCustomizableCatalogoResponse>(`${this.apiUrl}CustomEmpresa/GetCampoNuevo`, request);
  }

  deleteCampoCustomizableCatalogo(campo: ICampoCustomizableCatalogo): Observable<ICampoCustomizableCatalogoDeleteResponse> {
    const request: ICampoCustomizableCatalogoDeleteRequest = {
      que: 3, // Acción de eliminar
      sCampo: campo.sCampo,
      sTabla: campo.sTabla,
      sTipo: '',
      iLongitud: 0,
      sCampoValida: campo.sCampoValida || '',
      sOperador: campo.sOperador || ''
    };
    return this.http.post<ICampoCustomizableCatalogoDeleteResponse>(`${this.apiUrl}GetMnto/Getnvocmptaberr`, request);
  }

  getTiposOptions(): Observable<ITipoResponse> {
    const request: ITipoRequest = {
      sTabla: "cmtbl_nvoscamptablas",
      sCampo: "sTipo",
      iIdioma: 0
    };
    return this.http.post<ITipoResponse>(`${this.apiUrl}OpcionesSolicitud/GetOpcionesVariables`, request);
  }

  getTablasOptions(sUsuario: string): Observable<ITablaResponse> {
    const request: ITablaRequest = {
      iPipe: 0,
      sUsuario: sUsuario,
      iIdioma: 0
    };
    return this.http.post<ITablaResponse>(`${this.apiUrl}CentrodePagos/GetPvtTwhrA5`, request);
  }

  saveCampoCustomizableCatalogo(campo: ICampoCustomizableCatalogo): Observable<ICampoCustomizableCatalogoSaveResponse> {
    const request: ICampoCustomizableCatalogoSaveRequest = {
      que: 1, // Acción de guardar
      sCampo: campo.sCampo,
      sTabla: campo.sTabla,
      sTipo: campo.sTipo,
      iLongitud: campo.iLongitud,
      sCampoValida:  '',
      sOperador: ''
    };
    return this.http.post<ICampoCustomizableCatalogoSaveResponse>(`${this.apiUrl}GetMnto/Getnvocmptaberr`, request);
  }

  updateCampoCustomizableCatalogo(campo: ICampoCustomizableCatalogo): Observable<ICampoCustomizableCatalogoSaveResponse> {
    const request: ICampoCustomizableCatalogoSaveRequest = {
      que: 2, // Acción de actualizar
      sCampo: campo.sCampo,
      sTabla: campo.sTabla,
      sTipo: campo.sTipo,
      iLongitud: campo.iLongitud,
      sCampoValida:  '',
      sOperador: ''
    };
    return this.http.post<ICampoCustomizableCatalogoSaveResponse>(`${this.apiUrl}GetMnto/Getnvocmptaberr`, request);
  }
} 